export enum Mode {
  AMENDMENT,
  APPLICATION,
  RENEWAL,
  UPDATE,
}
